import React from "react";
import Markdown from "markdown-to-jsx";
import DOMPurify from "dompurify";

const elements = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan",
];

const allowedElements = ["a", "b", "strong", "em", "u", "code", "del"];

const CustomLink = ({ children, ...props }) => (
  <a {...props} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

// Detecta HTML
const isHtml = (str) =>
  typeof str === "string" && /<\/?[a-z][\s\S]*>/i.test(str);

const MarkdownWrapper = ({ children }) => {
  // ❗ Hook sempre executado, antes de qualquer condicional
  const markdownOptions = React.useMemo(() => {
    const opts = {
      disableParsingRawHTML: true,
      forceInline: true,
      overrides: { a: { component: CustomLink } },
    };

    elements.forEach((el) => {
      if (!allowedElements.includes(el)) {
        opts.overrides[el] = (element) => element.children || null;
      }
    });

    return opts;
  }, []);

  // Agora pode retornar condicional livremente
  if (!children) return null;

  // Detectou HTML → exibe como HTML sanitizado
  if (isHtml(children)) {
    return (
      <div
        className="html-message"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(children),
        }}
      />
    );
  }

  // Markdown básico
  let text = children;
  text = text.replace(/\*(.*?)\*/g, "**$1**");
  text = text.replace(/~(.*?)~/g, "~~$1~~");

  return <Markdown options={markdownOptions}>{text}</Markdown>;
};

export default MarkdownWrapper;
